import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    NumberInput,
    NumberInputField,
    Select,
    SimpleGrid,
    Text,
    useColorModeValue,
    useToast,
} from "@chakra-ui/react";
import axios from "axios";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { CentroCusto } from "models/centro_custo_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContaFinanceiro } from "models/conta_financeiro";
import { ContasPagar } from "models/contas_pagar";
import { Depto } from "models/depto_type";
import { FinanceCategoryType } from "models/finance_category";
import { LancamentoFinanceiro } from "models/lancamento_type";
import { OrcamentoDepto } from "models/orcamento_departamento";
import { OSType } from "models/os_type";
import { PessoaType } from "models/person_type";
import { OptionType } from "models/select_mode";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import useSubCategory from "views/admin/finance/subCategories/hooks/useSubCategory";

interface IContasPagarForm {
    show: boolean;
    showModal: (show: boolean, all?:boolean) => void;
    osList: OSType[];
    fornecedor: PessoaType[];
}
const ContasPagarForm = ({
    show,
    showModal,
    osList,
    fornecedor: fornecedores,
}: IContasPagarForm) => {
    const toast = useToast({
        position: "top-right",
        duration: 3000,
    });

    const borderColor = useColorModeValue("white", "navy.800");
    const textColor = useColorModeValue("navy.700", "white");
    const brandStars = useColorModeValue("brand.500", "brand.400");

    const loadAcountsBase = (osListLocal: OSType[]) => {
        const userData = JSON.parse(localStorage.getItem("user"));
        return osListLocal.map((item) => {
            const obj = {
                // ocorrenciaId: "",
                empresaSaidaId: "",
                centroCustoId: "",
                orcamentoDeptoId: "",
                vencOriginal: new Date(),
                vencimento: new Date(),
                numDocumento: "",
                dataEmissao: new Date(),
                competencia: new Date(),
                contaFinanceiroId: "",
                tipoRecebimento: "",
                categoriaLancamentoId: "",
                subCategoriaLancamentoId: "",
                parcelaVencimento: Number(moment(new Date()).format("DD")),
                parcela: 0,
                pessoaId: item.pessoaId,
                condicaoPagamentoId: item.condicaoPagamentoId,
                historico: "Gerado automaticamente a partir da OS",
                usuarioId: userData?.id,
                idEmpresa: userData?.idEmpresa,
                valor: Number(item.producaoTotal),
                origem: '2',
                osId: item.id,
                deptoId: "",
                selectedCategorias: {} as FinanceCategoryType,
            };

            return obj;
        });
    }

    const osListFiltered = useMemo(
        () => osList.filter((item) =>
            !item.financeiroGerado && item.id && !item.contasPagarId)
            .sort((a, b) => a.produtoId.localeCompare(b.produtoId)),
        [osList]
    );
    const [osListState, setOsListState] = useState(loadAcountsBase(osListFiltered));
    console.log("osListState", osListState);
    
    const [osListValidateFields, setOsListValidateFields] = useState<typeof osListState>([]);
    const [loading, setLoading] = useState(false);
    const [acountsList, setAccountTypeList] = useState<ContasPagar[]>([]);
    const [condicaoPagamentos, setCondicaoPagamentos] = useState<CondicaoPagamento[]>([]);
    const [categoria, setCategoria] = useState<FinanceCategoryType[]>([]);
    const [contaFinanceiroLista, setContaFinanceiroLista] = useState<ContaFinanceiro[]>([]);
    const [listDepto, setListDepto] = useState<OrcamentoDepto[]>([]);
    const [filiais, setFilial] = useState<PessoaType[]>();
    const [depto, setDepto] = useState<Depto[]>([]);
    const [centroCusto, setCentroCusto] = useState<CentroCusto[]>([]);
    const [itemList, setItemList] = useState<LancamentoFinanceiro[]>([]);
    const [oldList, setOldList] = useState<LancamentoFinanceiro[]>([]);
    const { lista } = useSubCategory();

    const getAcuntByItem = (item: OSType) => {
        return osListState.find((acount) => acount.osId === item.id);
    };

    const loadData = async () => {
        const userData = JSON.parse(localStorage.getItem("user"));
        const response = await axios.get(
            process.env.REACT_APP_API_URL + "/contas-pagar/list/" + userData?.idEmpresa
        );
        if (response.data) {
            setAccountTypeList(response.data);
        }
    };

    const loadPagamento = async () => {
        const userData = JSON.parse(localStorage.getItem("user"));
        const response = await axios.get(
            process.env.REACT_APP_API_URL + "/condicao-pagamento/list/" + userData?.idEmpresa
        );
        if (response.data) {
            setCondicaoPagamentos(response.data);
            initParcelasCondition(response.data);
        }
    };

    const loadDepto = async () => {
        const userData = JSON.parse(localStorage.getItem("user"));
        const response = await axios.get(
            process.env.REACT_APP_API_URL + "/departamento/list/" + userData?.idEmpresa
        );
        if (response.data) {
            setDepto(response.data);
        }
    };

    const loadCategory = async () => {
        const userData = JSON.parse(localStorage.getItem("user"));
        const response = await axios.get(
            process.env.REACT_APP_API_URL + "/financeiro-categoria/list/" + userData?.idEmpresa
        );
        if (response.data) {
            setCategoria(response.data);
        }
    };

    const loadContaFinaceiro = async () => {
        const userData = JSON.parse(localStorage.getItem("user"));
        const response = await axios.get(
            process.env.REACT_APP_API_URL + "/conta-financeiro/list/" + userData?.idEmpresa
        );
        if (response.data) {
            setContaFinanceiroLista(response.data);
        }
    };

    const loadOrcamentoDepto = async () => {
        const userData = JSON.parse(localStorage.getItem("user"));
        const response = await axios.get(
            process.env.REACT_APP_API_URL + "/orcament-departamento/list/" + userData?.idEmpresa
        );
        if (response.data) {
            setListDepto(response.data);
        }
    };

    const loadEmpresas = async () => {
        const userData = JSON.parse(localStorage.getItem("user"));
        const response = await axios.get(
            process.env.REACT_APP_API_URL + "/orcamento/filial/" + userData?.idEmpresa
        );
        if (response.data) {
            setFilial(response.data);
        }
    };

    const validate = () => {
        return osListFiltered.every((item) => {
            return Object.values(item).every((value) => {
                return value !== "";
            });
        });
    };

    const validateField = (osId: string, key: keyof typeof osListState[0]) => {
        const item = osListState.find((acount) => acount.osId === osId);
        if (item) {
            return item[key] !== "" && item[key] !== undefined && item[key] !== null;
        }
        return false;
    }

    const showError = (title = "Erro!", description = "Houve um erro, tente mais tarde!") => {
        toast({
            title,
            description,
            status: "error",
            isClosable: true,
        });
    };

    const changeAccountInOsListState = (osId: string, key: keyof typeof osListState[0], value: any) => {
        setOsListState((prevList) =>
            prevList.map((item) =>
                item.osId === osId ? { ...item, [key]: value } : item
            )
        );
    }

    const changeDepto = (osId: string, item: string) => {
        const selected = depto?.find((f) => f.id === item);
        if (selected) {
            changeAccountInOsListState(osId, "deptoId", selected.id);
            setCentroCusto(selected.CentroCusto);
        }
    };

    const changeConta = (osId: string, item: string) => {
        const selected = contaFinanceiroLista?.find((f) => f.id === item);
        if (selected) {
            changeAccountInOsListState(osId, "contaFinanceiroId", selected.id);
        }
    };

    const changeCategoria = (osId: string, item: string) => {
        const selected = categoria?.find((f) => f.id === item);
        if (selected) {
            changeAccountInOsListState(osId, "categoriaLancamentoId", selected.id);
            changeAccountInOsListState(osId, "selectedCategorias", selected);
        }
    };

    const changeSubCategoria = (osId: string, item: string) => {
        const selected = lista?.find((f) => f.id === item);
        if (selected) {
            changeAccountInOsListState(osId, "subCategoriaLancamentoId", selected.id);
        }
    };

    const changeCentroCusto = (osId: string, item: string) => {
        const selected = centroCusto?.find((f) => f.id === item);
        if (selected) {
            changeAccountInOsListState(osId, "centroCustoId", selected.id);
        }
    };

    const changeDeptoOrcamento = (osId: string, item: string) => {
        const selected = listDepto?.find((f) => f.id === item);
        if (selected) {
            changeAccountInOsListState(osId, "orcamentoDeptoId", selected.id);
        }
    };

    const onChangeFilial = (osId: string, item: string) => {
        const selected = filiais.find((a) => a.id === item);
        if (selected) {
            changeAccountInOsListState(osId, "empresaSaidaId", selected.id);
        }
    }

    const initParcelasCondition = (condicaoPagamento: CondicaoPagamento[]) => {
        osListFiltered.forEach((os) => {
            const condicao = condicaoPagamento.find((f) => f.id === os.condicaoPagamentoId);
            console.log("condicao", condicao, os, osListFiltered, osListState);

            changeAccountInOsListState(os.id, "parcela", Number(condicao?.parcelas));
        });
    }

    const gerarContasPagar = async () => {
        if (!validate()) {
            showError("Erro!", "Preencha todos os campos obrigatórios!");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL + "/contas-pagar/OS",
                osListState
            );
            if (response.data) {
                toast({
                    title: "Sucesso!",
                    description: "Contas a pagar geradas com sucesso!",
                    status: "success",
                });

                setOsListState(loadAcountsBase(osListFiltered));
                showModal(false, true);
            } else {
                showError("Erro!", "Houve um erro ao gerar as contas a pagar!");
            }
        } catch (error) {
            showError("Erro!", "Houve um erro ao gerar as contas a pagar!");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const initialize = async () => {
            setLoading((prev) => (prev = true));
            try {
                await Promise.all([
                    loadData(),
                    loadPagamento(),
                    loadDepto(),
                    loadCategory(),
                    // loadFornecedores(),
                    loadContaFinaceiro(),
                    // loadUsers(),
                    loadOrcamentoDepto(),
                    loadEmpresas(),
                ]);
            } catch (error) {
                // Handle errors if needed
                console.error("Error during initialization:", error);
            } finally {
                setLoading((prev) => (prev = false));
            }
        };

        initialize();
    }, []);


    return (
        <Modal
            onClose={() => {
                showModal(false);
            }}
            size={"6xl"}
            isOpen={show}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    Gerar Contas a Pagar
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {osListFiltered.map((item, index) => {
                        const isLastInGroup = index === osListFiltered.length - 1 || item.produtoId !== osListFiltered[index + 1].produtoId;

                        return (
                            <Box
                                key={"__contas-pagar" + index}
                                {...(isLastInGroup && { borderBottom: "1px solid #E2E8F0" })}
                                py={4}
                            >
                                <Text
                                    textAlign="left"
                                    color={"#422AFB"}
                                    fontWeight={"bold"}
                                    fontSize={20}
                                >
                                    {item.descricao}. {item.osNum} - {fornecedores.find((f) => f.id === item.pessoaId)?.nome}
                                </Text>
                                <SimpleGrid columns={4} spacing={4} mt={3}>
                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="500"
                                            color={textColor}
                                            mb="8px"
                                        >
                                            Empresa Saída/Filial
                                        </FormLabel>
                                        <Select size="md"
                                            onChange={(e) => onChangeFilial(item.id, e.target.value)}
                                            defaultValue={getAcuntByItem(item)?.empresaSaidaId}
                                            isInvalid={!validateField(item.id, "empresaSaidaId")}
                                        >
                                            <option value={"0"}>NENHUMA</option>
                                            {filiais?.map((item) => (
                                                <option value={item.id}>{item.nome}</option>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="500"
                                            color={textColor}
                                        >
                                            Departamento<Text color={brandStars}>*</Text>
                                        </FormLabel>
                                        <Box alignSelf={"flex-start"}>
                                            <AutoComplete<OptionType, false, GroupBase<OptionType>>
                                                size={"md"}
                                                onChange={(e) => {
                                                    changeDepto(item.id, e.value)
                                                }}
                                                placeholder="Buscar..."
                                                isDisabled={false}
                                                name={"fornecedor"}
                                                isInvalid={!validateField(item.id, "deptoId")}
                                                value={{
                                                    label: depto?.find((f) => f.id === getAcuntByItem(item)?.deptoId)?.nome,
                                                    value: getAcuntByItem(item)?.deptoId,
                                                }}
                                                options={depto?.map((item) => {
                                                    return {
                                                        label: item?.nome,
                                                        value: item?.id,
                                                    };
                                                })}
                                            />
                                        </Box>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="500"
                                            color={textColor}
                                        >
                                            Centro de Custos<Text color={brandStars}>*</Text>
                                        </FormLabel>
                                        <Box alignSelf={"flex-start"}>
                                            <AutoComplete<OptionType, false, GroupBase<OptionType>>
                                                size={"md"}
                                                onChange={(e) => changeCentroCusto(item.id, e.value)}
                                                placeholder="Buscar..."
                                                isDisabled={false}
                                                name={"fornecedor"}
                                                isInvalid={!validateField(item.id, "centroCustoId")}
                                                value={{
                                                    label: centroCusto?.find(
                                                        (f) => f.id === getAcuntByItem(item)?.centroCustoId
                                                    )?.nome,
                                                    value: getAcuntByItem(item)?.centroCustoId,
                                                }}
                                                options={centroCusto?.map((item) => {
                                                    return {
                                                        label: item?.nome,
                                                        value: item?.id,
                                                    };
                                                })}
                                            />
                                        </Box>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="500"
                                            color={textColor}
                                        >
                                            Plano de Contas<Text color={brandStars}>*</Text>
                                        </FormLabel>
                                        <Box alignSelf={"flex-start"}>
                                            <AutoComplete<OptionType, false, GroupBase<OptionType>>
                                                size={"md"}
                                                onChange={(e) => changeDeptoOrcamento(item.id, e.value)}
                                                placeholder="Buscar..."
                                                isDisabled={false}
                                                name={"planoContas"}
                                                isInvalid={!validateField(item.id, "orcamentoDeptoId")}
                                                value={{
                                                    label: listDepto?.find(
                                                        (f) => f.id === getAcuntByItem(item)?.orcamentoDeptoId
                                                    )?.descricao,
                                                    value: getAcuntByItem(item)?.orcamentoDeptoId,
                                                }}
                                                options={listDepto?.map((item) => {
                                                    return {
                                                        label: item?.descricao,
                                                        value: item?.id,
                                                    };
                                                })}
                                            />
                                        </Box>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="bold"
                                            color={textColor}
                                            mb="8px"
                                        >
                                            Vencimento Original
                                        </FormLabel>
                                        <SingleDatepicker
                                            name="date-input-validade"
                                            configs={{
                                                dateFormat: "dd/MM/yyyy",
                                                dayNames: "DSTQQSS".split(""), // length of 7
                                                monthNames:
                                                    "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                                                        " "
                                                    ), // length of 12
                                                firstDayOfWeek: 0,
                                                // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
                                            }}
                                            propsConfigs={{
                                                dayOfMonthBtnProps: {
                                                    selectedBtnProps: {
                                                        background: "#422afb",
                                                        color: "white",
                                                    },
                                                },
                                            }}
                                            date={
                                                getAcuntByItem(item)?.vencOriginal !== undefined
                                                    ? new Date(getAcuntByItem(item)?.vencOriginal)
                                                    : new Date()
                                            }
                                            onDateChange={(date: any) => {
                                                changeAccountInOsListState(item.id, "vencOriginal", date);
                                            }}
                                        />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="bold"
                                            color={textColor}
                                            mb="8px"
                                        >
                                            Vencimento
                                        </FormLabel>
                                        <SingleDatepicker
                                            name="date-input-validade"
                                            configs={{
                                                dateFormat: "dd/MM/yyyy",

                                                dayNames: "DSTQQSS".split(""), // length of 7
                                                monthNames:
                                                    "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                                                        " "
                                                    ), // length of 12
                                                firstDayOfWeek: 0,
                                                // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
                                            }}
                                            propsConfigs={{
                                                dayOfMonthBtnProps: {
                                                    selectedBtnProps: {
                                                        background: "#422afb",
                                                        color: "white",
                                                    },
                                                },
                                            }}
                                            date={
                                                getAcuntByItem(item)?.vencimento !== undefined
                                                    ? new Date(getAcuntByItem(item)?.vencimento)
                                                    : new Date()
                                            }
                                            minDate={new Date(moment(new Date()).format("YYYY-MM-DD"))}
                                            onDateChange={(date: any) => {
                                                const dateMoment = moment(date).format("DD");
                                                changeAccountInOsListState(item.id, "vencimento", date);
                                                changeAccountInOsListState(item.id, "parcelaVencimento", Number(dateMoment));
                                                // if (
                                                //     selectedCondicaoPagamentos &&
                                                //     accountSelected?.valor &&
                                                //     selectedFornecedor &&
                                                //     accountSelected?.tipoRecebimento
                                                // ) {
                                                //     generateParcela(
                                                //         selectedCondicaoPagamentos.id,
                                                //         date,
                                                //         accountSelected?.valor,
                                                //         selectedFornecedor?.id,
                                                //         accountSelected?.tipoRecebimento
                                                //     );
                                                // }
                                            }}
                                        />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="500"
                                            color={textColor}
                                            mb="8px"
                                        >
                                            Número do Documento
                                        </FormLabel>
                                        <NumberInput
                                            min={0}
                                            onChange={(e: string) => {
                                                changeAccountInOsListState(item.id, "numDocumento", e);
                                            }}
                                            isInvalid={!validateField(item.id, "numDocumento")}
                                            defaultValue={getAcuntByItem(item)?.numDocumento}
                                        >
                                            <NumberInputField />
                                        </NumberInput>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="bold"
                                            color={textColor}
                                            mb="8px"
                                        >
                                            Data de Emissão
                                        </FormLabel>
                                        <SingleDatepicker
                                            name="date-input-validade"
                                            configs={{
                                                dateFormat: "dd/MM/yyyy",
                                                dayNames: "DSTQQSS".split(""), // length of 7
                                                monthNames:
                                                    "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                                                        " "
                                                    ), // length of 12
                                                firstDayOfWeek: 0,
                                                // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
                                            }}
                                            propsConfigs={{
                                                dayOfMonthBtnProps: {
                                                    selectedBtnProps: {
                                                        background: "#422afb",
                                                        color: "white",
                                                    },
                                                },
                                            }}
                                            date={
                                                getAcuntByItem(item)?.dataEmissao !== undefined
                                                    ? new Date(getAcuntByItem(item)?.dataEmissao)
                                                    : new Date()
                                            }
                                            onDateChange={(date: any) => {
                                                changeAccountInOsListState(item.id, "dataEmissao", date);
                                            }}
                                        />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="bold"
                                            color={textColor}
                                            mb="8px"
                                        >
                                            Competência
                                        </FormLabel>
                                        <SingleDatepicker
                                            name="date-input-validade"
                                            configs={{
                                                dateFormat: "dd/MM/yyyy",
                                                dayNames: "DSTQQSS".split(""), // length of 7
                                                monthNames:
                                                    "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                                                        " "
                                                    ), // length of 12
                                                firstDayOfWeek: 0,
                                                // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
                                            }}
                                            propsConfigs={{
                                                dayOfMonthBtnProps: {
                                                    selectedBtnProps: {
                                                        background: "#422afb",
                                                        color: "white",
                                                    },
                                                },
                                            }}
                                            date={
                                                getAcuntByItem(item)?.competencia !== undefined
                                                    ? new Date(getAcuntByItem(item)?.competencia)
                                                    : new Date()
                                            }
                                            onDateChange={(date: any) => {
                                                changeAccountInOsListState(item.id, "competencia", date);
                                            }}
                                        />
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="500"
                                            color={textColor}
                                        >
                                            Conta para Baixa<Text color={brandStars}>*</Text>
                                        </FormLabel>
                                        <Box alignSelf={"flex-start"}>
                                            <AutoComplete<OptionType, false, GroupBase<OptionType>>
                                                size={"md"}
                                                onChange={(e) => {
                                                    changeConta(item.id, e.value);
                                                }}
                                                placeholder="Buscar..."
                                                isDisabled={false}
                                                name={"contaFinanceiroLista"}
                                                isInvalid={!validateField(item.id, "contaFinanceiroId")}
                                                defaultValue={{
                                                    label: contaFinanceiroLista?.find(
                                                        (f) => f.id === getAcuntByItem(item)?.contaFinanceiroId
                                                    )?.descricao,
                                                    value: getAcuntByItem(item)?.contaFinanceiroId
                                                }}
                                                options={contaFinanceiroLista?.map((item) => {
                                                    return {
                                                        label: item?.descricao,
                                                        value: item?.id,
                                                    };
                                                })}
                                            />
                                        </Box>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="500"
                                            color={textColor}
                                            mb="8px"
                                        >
                                            Tipo de Pagamento
                                        </FormLabel>

                                        <Select
                                            size="md"
                                            onChange={(e) => {
                                                changeAccountInOsListState(item.id, "tipoRecebimento", e.target.value);
                                                // generateParcela(
                                                //     selectedCondicaoPagamentos.id,
                                                //     accountSelected.vencimento,
                                                //     accountSelected?.valor,
                                                //     selectedFornecedor?.id,
                                                //     e.target.value
                                                // );
                                            }}
                                            isInvalid={!validateField(item.id, "tipoRecebimento")}
                                            defaultValue={getAcuntByItem(item)?.tipoRecebimento}
                                        >
                                            <option value={"0"}>SELECIONE O TIPO DE PAGAMENTO</option>
                                            <option value={"1"}>BOLETO</option>
                                            <option value={"2"}>CHEQUE</option>
                                            <option value={"3"}>CARTÃO</option>
                                            <option value={"4"}>DINHEIRO</option>
                                            <option value={"5"}>DEPÓSITO</option>
                                            <option value={"6"}>DÉBITO EM CONTA</option>
                                            <option value={"7"}>FATURA</option>
                                            <option value={"8"}>ARRECADAÇÃO/RECEBIMENTO</option>
                                            <option value={"9"}>TRANSFÊRENCIA</option>
                                            <option value={"10"}>PIX</option>
                                        </Select>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="500"
                                            color={textColor}
                                        >
                                            Categoria Financeira<Text color={brandStars}>*</Text>
                                        </FormLabel>
                                        <Box alignSelf={"flex-start"}>
                                            <AutoComplete<OptionType, false, GroupBase<OptionType>>
                                                size={"md"}
                                                onChange={(e) => {
                                                    changeCategoria(item.id, e.value)
                                                }}
                                                placeholder="Buscar..."
                                                isDisabled={false}
                                                name={"categoria"}
                                                defaultValue={{
                                                    label: categoria?.find(
                                                        (f) => f.id === getAcuntByItem(item)?.categoriaLancamentoId
                                                    )?.nome,
                                                    value: getAcuntByItem(item)?.categoriaLancamentoId,
                                                }}
                                                isInvalid={!validateField(item.id, "categoriaLancamentoId")}
                                                options={categoria?.map((item) => {
                                                    return {
                                                        label: item?.nome,
                                                        value: item?.id,
                                                    };
                                                })}
                                            />
                                        </Box>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel
                                            display="flex"
                                            ms="4px"
                                            fontSize="sm"
                                            fontWeight="500"
                                            color={textColor}
                                        >
                                            SubCategoria Financeira<Text color={brandStars}>*</Text>
                                        </FormLabel>
                                        <Box alignSelf={"flex-start"}>
                                            <AutoComplete<OptionType, false, GroupBase<OptionType>>
                                                size={"md"}
                                                onChange={(e) => {
                                                    changeSubCategoria(item.id, e.value)
                                                }}
                                                placeholder="Buscar..."
                                                isDisabled={false}
                                                name={"subcategoria"}
                                                isInvalid={!validateField(item.id, "subCategoriaLancamentoId")}
                                                value={{
                                                    label: getAcuntByItem(item)?.selectedCategorias?.SubCategoriaLancamento?.find(
                                                        (f) => f.id === getAcuntByItem(item)?.subCategoriaLancamentoId
                                                    )?.nome,
                                                    value: getAcuntByItem(item)?.subCategoriaLancamentoId,
                                                }}
                                                options={getAcuntByItem(item)?.selectedCategorias?.SubCategoriaLancamento?.map(
                                                    (item) => {
                                                        return {
                                                            label: item?.nome,
                                                            value: item?.id,
                                                        };
                                                    }
                                                )}
                                            />
                                        </Box>
                                    </FormControl>
                                </SimpleGrid>
                            </Box>
                        );
                    })}
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            showModal(false);
                        }}
                        variant="outline"
                        marginRight={4}
                    >
                        Fechar
                    </Button>
                    <Button
                        onClick={() => {
                            gerarContasPagar();
                         }}
                        colorScheme="brand"
                        isLoading={loading}
                    >
                        Gerar
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
export default ContasPagarForm;
